import { css } from '@emotion/css';

export const bottomSheeetContainer = css`
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 12px 16px 28px 16px;
  display: block;
  margin: 0 auto;
  width: 100%;
  max-width: 550px;

  hr {
    width: 100%;
    border: 0.5px solid #ededed;
    margin: 16px 0px;
  }

  h3 {
    color: #181818;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    margin: 0;
  }
`;
